/** Static asset in `public/yu-logo.png` (copied from project root Gemini export). */
export const LOGO_SRC = `${process.env.PUBLIC_URL || ''}/yu-logo.png`;
export const LOGO_ALT = 'Youth United — Thapar NGO Society';
